import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ArrowLeft, Loader2 } from "lucide-react";
import { AppDispatch, RootState } from "../../../store/store";
import {
  clearCurrentProduct,
  fetchProductById,
} from "../../../store/slices/product-slice";
import ProductDetail from "./product_detail";

const ProductDetailPage = () => {
  const { productId } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const [selectedCurrency, setSelectedCurrency] = useState("SAR");

  const {
    currentProduct: product,
    currentProductLoading: loading,
    currentProductError: error,
  } = useSelector((state: RootState) => state.products);

  useEffect(() => {
    if (productId) {
      dispatch(fetchProductById(productId));
    }

    // Cleanup when component unmounts
    return () => {
      dispatch(clearCurrentProduct());
    };
  }, [productId, dispatch]);

  const handleBack = () => {
    navigate(-1);
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <Loader2 className="w-8 h-8 animate-spin mx-auto mb-4 text-blue-600" />
          <p className="text-gray-600">Loading product...</p>
        </div>
      </div>
    );
  }

  if (error || !product) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-gray-900 mb-2">
            {error || "Product not found"}
          </h2>
          <p className="text-gray-600 mb-4">
            {error
              ? "Failed to load product details"
              : "The product you're looking for doesn't exist"}
          </p>
          <button
            onClick={handleBack}
            className="inline-flex items-center gap-2 text-blue-600 hover:text-blue-800 font-medium transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            Go back
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="sticky top-0 z-10 bg-white/80 backdrop-blur-md border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center h-16">
            <button
              onClick={handleBack}
              className="flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors"
            >
              <ArrowLeft className="w-5 h-5" />
              <span className="hidden sm:inline">Back</span>
            </button>
          </div>
        </div>
      </div>

      <ProductDetail product={product} selectedCurrency={selectedCurrency} />
    </div>
  );
};

export default ProductDetailPage;
